import { SelectProps, Space, Tag } from "antd";
import SelectBarStyle, { SelectWrapperStyle } from "./Select.style";
import { Customtagbar } from "config/global.style";
import ArrowDown from "components/Icons/ArrowDown";
import RemoveCloseIcon from "components/Icons/RemoveClose";

function SelectBar(props: SelectProps) {
  const {
    children,
    className,
    value,
  } = props;

  return (
    <SelectWrapperStyle>
      <SelectBarStyle
        {...(props)}
        className={className}
        suffixIcon={<ArrowDown />}
      >
        {children}
      </SelectBarStyle>
      {props?.mode === "tags" && (
        <div className="tagbar">
          <Customtagbar>
            <Space size={[0, 8]} wrap>
              {(value as string[])?.map((val: string) => (
                <Tag key={val} closable closeIcon={<RemoveCloseIcon />}>
                  {val}
                </Tag>
              ))}
            </Space>
          </Customtagbar>
        </div>
      )}
    </SelectWrapperStyle>
  );
}

export default SelectBar;
